import { render, staticRenderFns } from "./BancoInput.vue?vue&type=template&id=3ac071b2"
import script from "./BancoInput.vue?vue&type=script&lang=js"
export * from "./BancoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports